import { Api } from 'models/services/api';
import { CreateDishCategoryQuery } from 'models/services/graphql';

import { DishCategoryData, DishCategoryDataToCreate } from '../index';

type DataToCreate = {
  menuCategoryId: string;
  input: DishCategoryDataToCreate;
};

const RequestQuery = `
  mutation CreateDishCategory($menuCategoryId: ID!, $input: DishCategoryCreateInput!) {
    ${CreateDishCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    createDishCategory: DishCategoryData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: DishCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createDishCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };